module.exports = __webpack_public_path__ + "img/binti-home.6a7a3e05.png";